import '../src/styles/baseline.scss';
import '../src/styles/swiperjs.scss';

export { default } from '../src/pages/_app';
